import React, { useMemo, useState } from "react";
import { Formik } from "formik";
import { useAccessLogUIContext } from "../AccessLogUIContext";
import moment from "moment";
import { isEqual } from "lodash";
import { dd_MM_yyyy, YYYY_MM_DD } from "../../../utils/const";
import DatePicker from "react-datepicker";

const initialFilterValues = {
  material_code: "",
  serial_number: "",
  response_code: "",
  dealer_code:"",
  datefrom: "",
  dateto: "",
};

export function AccessLogFilter({ filterValues }) {
  const [datefrom, setDateFrom] = useState("");
  const [dateto, setDateTo] = useState("");
  const accessLogUIContext = useAccessLogUIContext();
  const accessLogUIProps = useMemo(() => {
    return {
      queryParams: accessLogUIContext.queryParams,
      setQueryParams: accessLogUIContext.setQueryParams,
    };
  }, [accessLogUIContext]);

  const prepareFilter = (queryParams, values) => {
    const {
      material_code,
      serial_number,
      response_code,
      dealer_code,
      datefrom,
      dateto,
    } = values;

    const newQueryParams = { ...queryParams };
    const filter = {};

    filter.material_code = material_code !== "" ? material_code : undefined;
    filter.serial_number = serial_number !== "" ? serial_number : undefined;
    filter.dealer_code = dealer_code !== "" ? dealer_code : undefined;
    filter.response_code = response_code !== "" ? response_code : undefined;
    
    if (datefrom && dateto) {
      const date = {
        datefrom: datefrom ? moment(datefrom).format(YYYY_MM_DD) : undefined,
        dateto: dateto ? moment(dateto).format(YYYY_MM_DD) : undefined,
      };
      filter.date = date !== "" ? date : undefined;
    }

    newQueryParams.filter = filter;
    return newQueryParams;
  };

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(accessLogUIProps.queryParams, values);
    if (!isEqual(newQueryParams, accessLogUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      accessLogUIProps.setQueryParams(newQueryParams);
    }
  };

  return (
    <>
      <Formik
        initialValues={initialFilterValues}
        onSubmit={(values) => {
          applyFilter(values);
        }}
        onReset={(values) => {
          applyFilter(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldValue,
          resetForm,
          handleReset,
        }) => (
          <form
            onSubmit={handleSubmit}
            className="form form-label-right"
            autoComplete="off"
            onReset={() => {
              resetForm(initialFilterValues);
              setDateFrom(null);
              setDateTo(null);
              handleReset();
            }}
          >
            <div className="form-group row">
              <div className="col-lg-2">
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control"
                  name="material_code"
                  placeholder="Search Material Code"
                  onBlur={handleBlur}
                  value={values.material_code}
                  onChange={(e) => {
                    setFieldValue("material_code", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  <b>Search</b> Material Code
                </small>
              </div>
              
              <div className="col-lg-2">
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control"
                  name="serial_number"
                  placeholder="Search Serial Number"
                  onBlur={handleBlur}
                  value={values.serial_number}
                  onChange={(e) => {
                    setFieldValue("serial_number", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  <b>Search</b> Serial Number
                </small>
              </div>

              <div className="col-lg-2">
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control"
                  name="dealer_code"
                  placeholder="Search Dealer Code"
                  onBlur={handleBlur}
                  value={values.dealer_code}
                  onChange={(e) => {
                    setFieldValue("dealer_code", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  <b>Search</b> Dealer Code
                </small>
              </div>

              <div className="col-lg-2">
                {/* <input
                  type="text"
                  autoComplete="off"
                  className="form-control"
                  name="response_code"
                  placeholder="Search Response Code"
                  onBlur={handleBlur}
                  value={values.response_code}
                  onChange={(e) => {
                    setFieldValue("response_code", e.target.value);
                    handleSubmit();
                  }}
                /> */}
                <select
                  className="form-control"
                  name="response_code"
                  placeholder="Filter Response Code"
                  onChange={(e) => {
                    setFieldValue("response_code", e.target.value);
                    handleSubmit();
                  }}
                  onBlur={handleBlur}
                  value={values.response_code}
                >
                  <option value="">All</option>
                  <option value="0">0</option>
                  <option value="-1">-1</option>
                  <option value="-2">-2</option>
                  <option value="-3">-3</option>
                  <option value="-4">-4</option>
                  <option value="-5">-5</option>
                </select>
                <small className="form-text text-muted">
                  <b>Filter</b> Response Code
                </small>
              </div>

              <div className="col-lg-2">
                <DatePicker
                  dateFormat={dd_MM_yyyy}
                  className=" form-control"
                  selected={datefrom}
                  onChange={(date) => {
                    setDateFrom(date);
                    setFieldValue("datefrom", date);
                    handleSubmit();
                  }}
                  placeholderText={"From"}
                  selectsStart
                  startDate={datefrom}
                  endDate={dateto}
                />

                <small className="form-text text-muted">
                  <b>Filter</b> by Validate Date
                </small>
              </div>
              <div className="col-lg-2">
                <DatePicker
                  className="form-control"
                  dateFormat={dd_MM_yyyy}
                  selected={dateto}
                  onChange={(date) => {
                    setDateTo(date);
                    setFieldValue("dateto", date);
                    handleSubmit();
                  }}
                  placeholderText={"To"}
                  selectsEnd
                  startDate={datefrom}
                  endDate={dateto}
                  minDate={datefrom}
                />
              </div>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
}
